module.exports = __webpack_public_path__ + "static/media/agencyIQ_Logo.e1b3c849.png";